/**
 * Route-derived analytics flow for the customer PWA shell.
 * Donation journeys live under `/donate`; everything else is RETAIL.
 */
import { useMemo, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import type { AnalyticsFlow } from 'pi-kiosk-shared';
import { CustomerAnalyticsProvider } from './CustomerAnalyticsProvider.js';

export function resolveCustomerAnalyticsFlow(pathname: string): AnalyticsFlow {
  if (pathname.includes('/donate')) {
    return 'DONATION';
  }
  return 'RETAIL';
}

interface CustomerAnalyticsShellProps {
  readonly children: ReactNode;
  readonly analyticsConsentGranted?: boolean;
  readonly analyticsConsentVersion?: string;
  readonly analyticsConsentDecidedAtMs?: number | null;
}

export function CustomerAnalyticsShell({
  children,
  analyticsConsentGranted,
  analyticsConsentVersion,
  analyticsConsentDecidedAtMs,
}: CustomerAnalyticsShellProps): JSX.Element {
  const location = useLocation();
  const flow = useMemo(
    () => resolveCustomerAnalyticsFlow(location.pathname),
    [location.pathname],
  );
  return (
    <CustomerAnalyticsProvider
      flow={flow}
      analyticsConsentGranted={analyticsConsentGranted}
      analyticsConsentVersion={analyticsConsentVersion}
      analyticsConsentDecidedAtMs={analyticsConsentDecidedAtMs}
    >
      {children}
    </CustomerAnalyticsProvider>
  );
}
